import { useMutation } from "urql";

import { UpdateUserDocument } from "../../../graphql/generated.ts";

export function useUpdateUser() {
  return useMutation(UpdateUserDocument);
}
